import type { Event } from '@patsnap/tahiti-core';
import type { TrackerApiRequest } from '../../infrastructure/api-functions/tracker-api';

export const RavenService = Symbol('RavenService');

export interface TrackEventPayload {
    /**
     * 事件名字
     */
    sourceType: string;
    /**
     * 事件的模块名
     */
    eventType: string;
    /**
     * 一般是taskId之类的唯一标识
     */
    otherParam?: string;
    /**
     * 当前 Agent 的会话 ID。
     *
     * 任务创建成功但页面尚未跳转时，由调用方显式传入。
     */
    sessionId?: string;
    /**
     * 其他埋点参数
     */
    eventDetailStr?: Record<string, unknown>;
}

/**
 * 埋点请求已经组装完成后的调试事件。
 */
export interface RavenTrackEvent {
    /**
     * 埋点请求组装完成的时间戳。
     */
    timestamp: number;
    /**
     * 将要发送或已经记录的最终埋点请求。
     */
    request: TrackerApiRequest;
}

export interface RavenService {
    /**
     * 跟踪事件
     * @param eventCode 事件名称
     * @param data 埋点数据
     */
    track(eventCode: string, data: Partial<TrackEventPayload>): Promise<void>;
    /**
     * 监听已经组装完成的埋点请求。
     *
     * 该事件只用于调试和观测，业务实现可以不提供此能力。
     */
    readonly onTrack?: Event<RavenTrackEvent>;
}
